import { Box, Container, IconButton } from "@mui/material";
import { ArrowUpward } from '@mui/icons-material';

import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import { Helmet } from "react-helmet";

const DefaultLayout = () => {
    const [showButton, setShowButton] = useState(false);
    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.pageYOffset > 300) {
                setShowButton(true);
            } else {
                setShowButton(false);
            }
        });
    }, []);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    return (
        <>
            <Helmet>
                <meta name="keywords"
                    content={"About Ukraine"} />
            </Helmet>
            <Header />
            <Container component="main" sx={{ maxWidth: { lg: "1310px", md: "744px", xs: "350px" } }}>
                <Outlet />
                {showButton && (
                    <IconButton
                        aria-label="edit"
                        color="primary"
                        sx={{
                            border: 2,
                            borderRadius: "12px",
                            "&& .MuiTouchRipple-child": {
                                border: 0,
                                borderRadius: "10px",
                            },
                            position: "fixed",
                            bottom: "20px",
                            right: { xs: "10px", md: "30px" },
                            zIndex: 999
                        }}
                        onClick={scrollToTop}

                    >
                        <ArrowUpward fontSize="large" />
                    </IconButton>
                )}
            </Container>
            <Footer />
        </>
    );
}

export default DefaultLayout;